import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { GlobalPageHeaderComponent } from '../../../../../../../../components/global-page-header/global-page-header.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { convertMinutesToTime } from '../../../../../../helper/convertSecondsToTime';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { CompaniesAddComponent } from '../../../../../../../../pages/home/companies/companies-add/companies-add.component';
import { FunctionParametersSettingsWeltico2ClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { FunctionParametersSettingWeltico2ClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-weltico2-clock-week-screen/function-parameters-setting-weltico2-clock-week-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p00039-eclairage-mise-en-oeuvre-prog-eclairage',
  templateUrl:
    './p00039-eclairage-mise-en-oeuvre-prog-eclairage.component.html',
  styleUrls: [
    './p00039-eclairage-mise-en-oeuvre-prog-eclairage.component.scss',
  ],
  imports: [
    IonFooter,
    IonButton,
    IonContent,
    HeaderConfigurationComponent,
    TranslatePipe,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    GlobalPageHeaderComponent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
    MinuterieLabelComponent,
    TwoChoicesControlComponent,
    LargedLinkComponent,
    LabelDescriptionComponent,
  ],
})
export class P00039EclairageMiseEnOeuvreProgEclairageComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  async goToFunctionParametersSettingsWeltico2ClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsWeltico2ClockScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourLundi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourMardi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourMercredi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourJeudi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourVendredi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourSamedi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourDimanche',
          ),
        colorType: this.actionStack!.getValue(
          'eclairageStandardITypeEclairage',
        ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage4,
        'eclairageStandardPHorlogeWelticoJourLundi',
        hj.substring(0, 48),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage5,
        'eclairageStandardPHorlogeWelticoJourMardi',
        hj.substring(48, 96),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage5,
        'eclairageStandardPHorlogeWelticoJourMercredi',
        hj.substring(96, 144),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage6,
        'eclairageStandardPHorlogeWelticoJourJeudi',
        hj.substring(144, 192),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage6,
        'eclairageStandardPHorlogeWelticoJourVendredi',
        hj.substring(192, 240),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage7,
        'eclairageStandardPHorlogeWelticoJourSamedi',
        hj.substring(240, 288),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage7,
        'eclairageStandardPHorlogeWelticoJourDimanche',
        hj.substring(288, 336),
        null,
      );
    }
  }

  async goToFunctionParametersSettingWeltico2ClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingWeltico2ClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue(
          'eclairageStandardPHorlogeWelticoSemaine',
        ),
        colorType: this.actionStack!.getValue(
          'eclairageStandardITypeEclairage',
        ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage4,
        'eclairageStandardPHorlogeWelticoSemaine',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('eclairageStandardPHorlogeJour'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage,
        'eclairageStandardPHorlogeJour',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('eclairageStandardPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage,
        'eclairageStandardPHorlogeSemaine',
        hj,
        null,
      );
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly convertMinutesToTime = convertMinutesToTime;
}
